import Campaigns from "@/partial/campaign";

export default function CampaignPage() {
  return <Campaigns />;
}
